import React, { PropTypes } from 'react';
import styled from 'styled-components';
import { throttle } from 'lodash';

const Offset = styled.div`
  width: 100%;
  height: 52px;
  z-index: 1;
  position: relative;
`;

const Container = styled.div`
  background-color: ${props => props.theme.color.theme};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100vw;
  top: 0px;
  left: 0;
  position: fixed;
  transform: translateY(${props => (props.visible ? '0px' : '-52px')});
  transition: transform 0.2s ease-in;
`;

/**
 * This component displays a bar at the top of the screen which will show and hide based on the users scrolling.
 */
class TopNavigation extends React.Component {
  state = { visible: true };

  componentDidMount() {
    window.addEventListener(
      'scroll',
      throttle(() => this.determineNavigationVisibility(), 200)
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      'scroll',
      throttle(() => this.determineNavigationVisibility(), 200)
    );
  }

  previousScroll = 0;

  determineNavigationVisibility() {
    if (this.props.hideWhenScrolled) {
      this.setState({
        visible: window.scrollY <= this.previousScroll || window.scrollY <= 0,
      });
      this.previousScroll = window.scrollY;
    }
  }

  render() {
    return (
      <Offset>
        <Container visible={this.state.visible}>
          {this.props.children}
        </Container>
      </Offset>
    );
  }
}

TopNavigation.propTypes = {
  // True if the navigation should move off screen when the user scrolls down
  // and on screen when the user scrolls up
  hideWhenScrolled: PropTypes.bool,
};

TopNavigation.defaultProps = {
  hideWhenScrolled: true,
};

export default TopNavigation;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/TopNavigation.js